import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';

export default async function resetPassword(emailOrUsername: string, gid: string) {
  const headers = {};
  await addBrowserSideAppHeaders(headers);

  return await fetch(`/api/login/reset-password`, {
    method: 'POST',
    body: JSON.stringify({
      emailOrUsername,
      gid,
    }),
    headers: headers,
  });
}
